import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RecalculateTableService {

  recalculateTrigger: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }
}
